<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-row class="mx-0">
            <h2>{{ $t('global.menu.backoffice.push-notifications') }}</h2>
        </v-row>
        <v-row class="mb-3">
            <v-col cols="12">
                <v-col class="align-items-center">
                    <v-label class="mr-4">{{ $t('global.form.title') }}</v-label>
                    <v-text-field v-model="title" variant="outlined" density="compact" :hide-details="true">
                    </v-text-field>
                </v-col>
                <v-col class="align-items-center pb-0">
                    <v-label class="mr-4">{{ $t('global.form.description') }}</v-label><span>{{$t('global.char-remaining.text',{textLength:remainingChars})}} </span>
                    <v-textarea v-model="message" variant="outlined" density="compact" :hide-details="true">
                    </v-textarea>
                </v-col>
                <v-col cols="12" class="d-inline-flex pt-0">
                    <v-checkbox label="iOS" density="compact" hide-details="true" class="mr-2"></v-checkbox>
                    <v-checkbox label="Android" density="compact" hide-details="true"></v-checkbox>
                </v-col>
            </v-col>
            <v-col cols="12" class="justify-content-between d-flex">

                <div style="max-width:400px">
                    <span class="text-sm text-gray-500">Vorschau</span>
                    <div class="border p-3 rounded shadow-md w-80">
                        <div class="flex items-center space-x-2 mt-2">
                            <div>
                                <h4 class="font-semibold mb-1">{{ title || 'Titel der Nachricht' }}</h4>
                                <span class="text-sm text-gray-600 paragraphed-text">{{ message || 'Deine Nachricht erscheint hier.'
                                    }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <v-btn class="px-3 py-1 text-right" variant="flat" rounded="xl" size="large" color="primary">{{
                    $t('entity.action.send') }}</v-btn>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import { ref, inject, getCurrentInstance, nextTick,computed } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

export default {
    components: {

    },
    setup() {

        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const { t, locale } = useI18n();
        const title = ref('')
        const message = ref('')
        const maxLength = 100;

        const remainingChars = computed(() => maxLength - message.value.length);

        return {
            selectedLanguage,
            title,
            message,
            maxLength,
            remainingChars
        };
    },

    watch: {

    },

    data: () => ({
        admins: []
    }),

    computed: {
    },

    mounted() {
    },

    methods: {
    },
}
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    max-width: 600px;
    margin-top: 40px;
}
</style>

<style></style>

<style></style>